import messiImg from "../../assets/images/messi_onboarding.png";
import neymarImg from "../../assets/images/neymar_onboarding.png";
import ronaldoImg from "../../assets/images/ronaldo_onboarding.png";
import salahImg from "../../assets/images/salah_onboarding.png";
import fedeImg from "../../assets/images/fede_onboarding.png";
import backgroundImg from "../../assets/images/background_onboarding.png";
import tpLogoWordmark from "../../assets/images/tp_logo_wordmark.png";
import { auth_bg } from "../../constants/icons";

const AuthHero = ({ pageName }) => {
  const getDescData = () => {
    switch (pageName) {
      case "signin":
        return {
          title: "Welcome Back to TransferPitch!",
          description: "Manage your deals and stats effortlessly!",
        };
      case "signup":
        return {
          title: "Welcome to Transferpitch",
          description:
            "Designed for sports professionals, we ensure faster decisions, smarter deals, and a unified space to elevate the transfer experience, where clubs, agents, players, and organizers collaborate effortlessly. Manage deals, compare stats, and build pitches with ease.",
        };
      case "onboarding":
        return {
          title: "Setup your Transferpitch account",
          description:
            "Unlock the full potential of your TransferPitch experience. Complete your account setup to connect with clubs, agents, players, and organizers, and start managing deals and stats effortlessly!",
        };
      default:
        return {
          title: "Welcome to Transferpitch",
          description:
            "Designed for sports professionals, we ensure faster decisions, smarter deals, and a unified space to elevate the transfer experience, where clubs, agents, players, and organizers collaborate effortlessly. Manage deals, compare stats, and build pitches with ease.",
        };
    }
  };
  return (
    <div
      className="hidden md:flex w-[55%] bg-[#1C2536]  flex-col justify-center pl-16 pt-16 pb-16 relative"
      style={{
        backgroundImage: `url(${auth_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Wordmark logo, top-left of the dark panel (Marin, LOOPUI T4).
          Desktop only by construction — this whole panel is hidden below md;
          below md the auth pages render AuthMobileLogo in the form column
          instead (without it the mobile login had no branding at all). */}
      <img
        src={tpLogoWordmark}
        alt="TransferPitch"
        className="absolute top-8 left-16 h-10 w-auto"
      />
      <div className="">
        <h1 className="text-[40px] leading-[48px] font-bold text-white mb-4">
          {getDescData().title}
        </h1>
        {/* w-full max-w instead of a hard 580px: below ~1170px the hero
            column (55% - pl-16) is narrower than 580px and the fixed width
            ran under the right panel and was clipped (LOOPUI T1, 768px). */}
        <p className="text-[16px] w-full max-w-[580px] pr-6 min-[1200px]:pr-0 leading-[24px] text-[#6C737F] mb-4">
          {getDescData().description}
        </p>
        <p className="text-[14px] w-full max-w-[580px] pr-6 min-[1200px]:pr-0 leading-[22px] text-white mb-9">
          Join 2,000+ clubs and access licensed data on over 1 million players.
        </p>

        {/* The 5x120px row is 440px wide — wider than the hero column below
            ~1024px, so the last avatars were clipped by the right panel
            (LOOPUI T1, 768px). Below lg the avatars scale to 80px (row =
            288px, fits); from lg up they render exactly as before. */}
        <div className="flex items-center -ml-7 mb-8 w-[288px] h-[48px]">
          <img
            src={messiImg}
            alt="Player"
            className="w-20 h-20 lg:w-[120px] lg:h-[120px] rounded-lg relative z-50"
          />
          <img
            src={neymarImg}
            alt="Player"
            className="w-20 h-20 lg:w-[120px] lg:h-[120px] -ml-7 lg:-ml-10 rounded-lg relative z-40"
          />
          <img
            src={ronaldoImg}
            alt="Player"
            className="w-20 h-20 lg:w-[120px] lg:h-[120px] -ml-7 lg:-ml-10 rounded-lg relative z-30"
          />
          <img
            src={salahImg}
            alt="Player"
            className="w-20 h-20 lg:w-[120px] lg:h-[120px] -ml-7 lg:-ml-10 rounded-lg relative z-20"
          />
          <img
            src={fedeImg}
            alt="Player"
            className="w-20 h-20 lg:w-[120px] lg:h-[120px] -ml-7 lg:-ml-10 rounded-lg relative z-10"
          />
        </div>
      </div>
    </div>
  );
};

export default AuthHero;
